import styled from 'styled-components';
import {
  Image,
  Radio as SemanticRadio,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div``;

const ContainerRadio = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
  margin-top: 9px;
`;

const ContainerAddItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContainerSlider = styled.div`
  width: 150px;
  margin-left: 15px;
`;

const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ContainerUrl = styled.div`
  margin-top: 10px;
`;

const ContainerInput = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
`;

const ContainerInstruction = styled.div`
  margin-top: 10px;
`;

const ContainerError = styled.div`
  display: flex;
  justify-content: center;
`;

const ContainerUploadButton = styled.div`
  display: flex;
  justify-content: center;
  height: 50px;
`;

const ErrorMessage = styled(TextLayoutComponent.Error)`
  margin-bottom: 10px;
`;

const WarnBoxMessage = styled.div`
  margin: 8px 4px;
  padding: 4px 8px;
  border-radius: 2px;
  background-color: rgb(220, 230, 251);
  color: ${({ theme }) => theme.color.textSecondary};
`;

const Number = styled.div`
  margin-top: 6px;
  width: 16px;
  display: inline-flex;
  justify-content: center;
`;

const IconTitle = styled(Image)`
  &&&{
    width: 25px;
    height: 25px;
  }
`;

const Radio = styled(SemanticRadio)``;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const RatingValue = styled(TextLayoutComponent)``;

const Row = styled.div`
  flex: 4;
  padding: 0 25px;
`;

const TextDifficult = styled(TextLayoutComponent)`
  align-self: flex-end;
  flex: 1;
`;

const Title = styled(TextLayoutComponent)`
  margin-left: auto;

  ${(props) => props.theme.color[props.color] && `
    margin-left: 10px;
    color: ${props.theme.color[props.color]};
  `}

  font-weight: 500;
`;

const QuestionIndex = styled(TextLayoutComponent)`
  font-weight: 900;
  padding: 10px;
`;

const InputRange = styled.input`
  margin: 0 10px;
`;

const AnswersContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 10px 0;
`;

const InputAnswerContainer = styled.div`
  flex: 1;
  width: 320px;
  display: flex;
`;

const ContainerAddQuestion = styled.div`
  margin: 10px 0;
`;

const AddQuestion = styled.a`
  cursor: pointer;
  margin-top: 10px;
`;

const TextLink = styled.a``;

export const PreferenceUploadRowOptionsCol = styled.div`
  display: flex;
  justify-content: space-between;
  width: 30%;
  align-items: center;
  max-height: 38px;
`;
export const PreferenceUploadRowTextCol = styled.div`
  display: flex;
  width: 65%;
`;

export const PreferenceUploadRowContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 10px 0;
  justify-content: space-between;
`;

export {
  AddQuestion,
  AnswersContainer,
  Container,
  ContainerAddItem,
  ContainerAddQuestion,
  ContainerRadio,
  ContainerSlider,
  ContainerTitle,
  ContainerUrl,
  ContainerInput,
  ContainerInstruction,
  ContainerUploadButton,
  ContainerError,
  ErrorMessage,
  WarnBoxMessage,
  Number,
  Radio,
  RadioGroup,
  RatingValue,
  Row,
  TextDifficult,
  Title,
  IconTitle,
  InputAnswerContainer,
  InputRange,
  TextLink,
  QuestionIndex,
};
